import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/common/order/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/common/order/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/common/order/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/common/order/submit',
    method: 'post',
    data: row
  })
}

